export const moea_ic = {
    "header": {
        "changeLanguage": "切換語言",
        "link": "相關連結",
        "regulation": "投資法規",
        "guide": "操作說明",
        "register": "註冊",
        "logIn": "登入",
        "features": "系統功能",
        "maintain": "帳號資料維護",
        "logOut": "登出",
        "inquiry": "申請案件查詢",
        "faq": "FAQ",
        "caseProgress": "案件進度查詢",
        "InvestDataMgmt": "投資相關資料管理",
        "mergePDF": "附件合併"
    },
    "footer": {
        "issue": "系統操作問題，請撥客服專線",
        "tel": "電話號碼",
        "hotline": "客服信箱",
        "hotline2": "客服電話: (02)25867890#10897",
        "serviceHour": "服務時間：星期一～星期五",
        "address": "地址：100215 台北市中正區羅斯福路1段7號8樓（裕民大樓）"
    },
    "logInPage": {
        "announcement": "最新公告",
        "loadAnnouncement": "公告載入中",
        "noAnnouncement": "目前沒有公告",
        "view": "查看全部",
        "logIn": "登入",
        "register": "前往註冊",
        "account": "會員帳號",
        "enterAccount": "請輸入信箱",
        "password": "密碼",
        "enterPassword": "請輸入密碼",
        "forgot": "忘記密碼",
        "verifyCode": "驗證碼",
        "enterCode": "請輸入驗證碼"
    },
    "homeAbout": {
        "applyCase": "案件申請",
        "applyDescribe": "分為來臺投資、對外投資、人才投資相關投資申請事宜。",
        "apply": "我要申請",
        "caseFolder": "案件夾",
        "viewCase": "查看您的送件進度或案件草稿",
        "announcement": "系統公告",
        "seeMore": "查看更多",
    },
    "selectPlan": {
        "title": "新增申請案件",
        "taiwan": "來臺投資",
        "foreign": "國外投資",
        "investToChina": "赴大陸地區投資",
        "investToHk": "對港澳投資",
        "other": "其他",
        "search": "關鍵字搜尋",
        "noResult": "沒有找到相關結果",
        "a": "A表",
        "aName": "初次投資(含新設)",
        "b_b1": "B表/B-1表",
        "b_b1Name": "增加投資/減少投資現有事業",
        "c": "C表",
        "cName": "投資額審定",
        "d": "D表",
        "dName": "股權轉受讓",
        "e": "E表",
        "eName": "僑外資事業更名或變更營業項目",
        "f": "F表",
        "fName": "僑外資事業解散註銷投資",
        "g": "G表",
        "gName": "外國法人變更名稱/因境外併購，承受國內公司股權",
        "h": "H表",
        "hName": "僑外資事業轉投資",
        "other": "其他",
        "otherName": "變更/廢止/撤件/其他",
        "apply": "我要申請",
        "plan01": "初次投資(含新設)",
        "plan02": "增加投資現有事業",
        "plan03": "減少投資現有事業",
        "plan04": "投資額審定",
        "plan05": "僑外資事業更名或變更營業項目",
        "plan06": "外國法人變更名稱/因境外併購，承受國內公司股權",
        "plan07": "僑外資事業轉投資",
        "plan08": "計畫修正申請書",
        "plan09": "實行期限展延申請書",
        "plan10": "公開市場出售股份",
        "plan11": "轉投資事業更名或變更組織型態申請書",
        "plan12": "股權轉受讓",
        "plan13": "僑外資事業解散註銷投資",
        "plan14": "計畫廢止",
        "plan15": "投資人國籍或身分變更",
        "foreign_01": "A",
        "foreign_01Name": "對外投資申報書A",
        "foreign_02": "減資",
        "foreign_02Name": "投資事業減資",
        "foreign_03": "註銷",
        "foreign_03Name": "投資事業註銷",
        "foreign_04": "更名",
        "foreign_04Name": "投資事業或投資人更名",
        "foreign_05": "實行備查",
        "foreign_05Name": "對外實行備查",
        "hkmo_01": "A",
        "hkmo_01Name": "對港澳申報書A",
        "hkmo_02": "減資",
        "hkmo_02Name": "投資事業減資",
        "hkmo_03": "註銷",
        "hkmo_03Name": "投資事業註銷",
        "hkmo_04": "更名",
        "hkmo_04Name": "投資事業或投資人更名",
        "hkmo_05": "實行備查",
        "hkmo_05Name": "對港澳實行備查",
        "hkmo_06": "技術合作",
        "hkmo_06Name": "對港澳技術合作",
        "china_01": "A",
        "china_01Name": "對大陸投資申報書 A",
        "china_02": "減資",
        "china_02Name": "對大陸投資/轉投資 減資",
        "china_03": "盈餘匯回",
        "china_03Name": "對大陸投資/轉投資 盈餘匯回",
        "china_04": "案件註銷",
        "china_04Name": "對大陸投資/轉投資 案件註銷",
        "china_05": "事項變更",
        "china_05Name": "對大陸投資/轉投資 事項變更",
        "china_06": "專案審查案件投資計畫執行情形",
        "china_06Name": "對大陸投資列管申報 專案審查案件投資計畫執行情形",
        "china_07": "承諾事項執行情形",
        "china_07Name": "對大陸投資列管申報 承諾事項執行情形",
        "china_08": "實行備查",
        "china_08Name": "對大陸實行備查",
        "china_09": "技術合作",
        "china_09Name": "對大陸技術合作",
        "china_10": "對大陸B",
        "china_10Name": "對大陸投資申報書B(簡易)",
        "china_11": "對大陸C",
        "china_11Name": "對大陸投資申報書C(專案)",
        "other_01": "實習生申請書",
        "other_01Name": "企業及法人外國籍學生實習申請書",
    }
}
